import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import { toast } from 'react-toastify';
import { addFilesKeywords, deleteFilesKeywords } from '../../../../../services/CommonService';

const MAX_KEYWORDS = 10;

const MyFilesTag = ({ file, userId, fetchFiles }) => {
  const [show, setShow] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const [keywords, setKeywords] = useState(file.keywords ? file.keywords.split(", ") : []);
  const [error, setError] = useState("");

  const handleOpen = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setTagInput("");
    setError("");
  };

  const handleAddTags = async () => {
    const trimmedKeywords = tagInput
      .split(",")
      .map((k) => k.trim())
      .filter((k) => k);
    if (!trimmedKeywords.length) return;
    const newKeywords = trimmedKeywords.filter((k) => !keywords.includes(k));
    if (!newKeywords.length) {
      setError("Keywords already exist!");
      return;
    }
    if (keywords.length + newKeywords.length > MAX_KEYWORDS) {
      setError(`Maximum ${MAX_KEYWORDS} keywords allowed per file!`);
      return;
    }
    try {
      await addFilesKeywords({ user_id: userId, file_id: file.id, keyword: newKeywords.join(',') });
      setKeywords([...keywords, ...newKeywords]);
      setTagInput("");
      setError("");
      toast.success("Tags added successfully!");
      if (fetchFiles) fetchFiles();
    } catch (error) {
      setError("Failed to add tags. Please try again.");
      toast.error("Failed to add tags. Please try again.");
    }
  };

  const handleRemoveKeyword = async (keyword) => {
    try {
      await deleteFilesKeywords({ user_id: userId, file_id: file.id, keyword });
      setKeywords(keywords.filter((k) => k !== keyword));
      toast.success("Keyword removed successfully!");
      if (fetchFiles) fetchFiles();
    } catch (error) {
      setError("Failed to remove keyword. Please try again.");
      toast.error("Failed to remove keyword. Please try again.");
    }
  };

  return (
    <>
      <span className="d-flex align-items-center gap-2" onClick={handleOpen} style={{ cursor: "pointer" }}>
        <i className="bi bi-tag" /> Add Tag
      </span>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Manage Tags</Modal.Title>
          <div className="d-flex gap-2 align-items-center cur-pointer" onClick={handleClose}>
            <FaTimes size={20} />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <strong>File:</strong> {file.file_name}
          </div>
          <div className="mb-3">
            <strong className="me-2">
              Keywords ({keywords.length}/{MAX_KEYWORDS}):
            </strong>
            {keywords.length > 0 ? (
              keywords.map((keyword, index) => (
                <span key={index} className="badge bg-primary text-white me-2">
                  {keyword}
                  <FaTimes className="cursor-pointer ms-1" onClick={() => handleRemoveKeyword(keyword)} />
                </span>
              ))
            ) : (
              <span className="text-muted">No keywords</span>
            )}
          </div>
          <div className="form-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Enter tags (comma-separated)"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") handleAddTags();
              }}
            />
          </div>
          {error && <p className="text-danger">{error}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAddTags}>
            Add Tags
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MyFilesTag; 